import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import LocationSelector from '../location-selector';
import LanguageSelector from '../language-selector';
import { Menu, MenuContent, MenuTrigger } from '../Menu';
import { CaretIcon } from '../Icons';
import headerMessages from '../Header.messages';

const HeaderTopBar = ({
  intl, handleSelectLanguage, mainMenu, appMenu,
}) => {
  const renderMainMenu = () => {
    // Nodes are accepted as a prop
    if (!Array.isArray(mainMenu)) {
      return mainMenu;
    }

    return mainMenu.map((menuItem) => {
      const {
        type,
        href,
        content,
        submenuContent,
      } = menuItem;

      if (type === 'item') {
        return (
          <a key={`${type}-${content}`} className="nav-link" href={href}>{content}</a>
        );
      }

      return (
        <Menu key={`${type}-${content}`} tag="div" className="nav-item" respondToPointerEvents>
          <MenuTrigger tag="a" className="nav-link d-inline-flex align-items-center" href={href}>
            {content} <CaretIcon role="img" aria-hidden="true" focusable="false" />
          </MenuTrigger>
          <MenuContent className="pin-left pin-right shadow py-2">
            {submenuContent}
          </MenuContent>
        </Menu>
      );
    });
  };

  // Renders an optional App Menu for
  const renderAppMenu = () => {
    const { content: appMenuContent, menuItems } = appMenu;
    return (
      <Menu transitionClassName="menu-dropdown" transitionTimeout={250}>
        <MenuTrigger tag="a" className="nav-link d-inline-flex align-items-center">
          {appMenuContent} <CaretIcon role="img" aria-hidden="true" focusable="false" />
        </MenuTrigger>
        <MenuContent className="mb-0 dropdown-menu show dropdown-menu-right pin-right shadow py-2">
          {menuItems.map(({ type, href, content }) => (
            <a className={`dropdown-${type}`} key={`${type}-${content}`} href={href}>{content}</a>
          ))}
        </MenuContent>
      </Menu>
    );
  };

  return (
    <div className="header-top-bar">
      <div className="container-fluid">
        <LocationSelector id="header-location" isConfirmChanges />
        <LanguageSelector handleSelectLanguage={handleSelectLanguage} />
        <nav
          aria-label={intl.formatMessage(headerMessages['header.label.main.nav'])}
          className="nav main-nav header-top-nav"
        >
          {renderMainMenu()}
        </nav>
        {appMenu ? (
          <nav
            aria-label={intl.formatMessage(headerMessages['header.label.app.nav'])}
            className="nav app-nav"
          >
            {renderAppMenu()}
          </nav>
        ) : null}
      </div>
    </div>
  );
};

HeaderTopBar.defaultProps = {
  mainMenu: [],
  appMenu: null,
};

HeaderTopBar.propTypes = {
  intl: intlShape.isRequired,
  handleSelectLanguage: PropTypes.func.isRequired,
  mainMenu: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
      submenuContent: PropTypes.node,
    })),
  ]),
  appMenu: PropTypes.shape(
    {
      content: PropTypes.string,
      menuItems: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string,
          href: PropTypes.string,
          content: PropTypes.string,
        }),
      ),
    },
  ),
};

export default injectIntl(HeaderTopBar);
